import { Button, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Form, Formik } from 'formik';
import React from 'react';
import FormikInput from '../../../../components/atom/FormikInput';
import FormSection from '../../../../components/atom/FormSection';
import ReadersList from './ReadersList';
import { RouterPrompt } from '../../../../components/atom/RouterPrompt';

const LocationCreateOrEditForm = ({
    initialValues,
    locationId,
    onSubmit,
    stripeError,
    isCreate,
    onBack,
    submitLocation
}) => {
    const defaultValues = {
        display_name: initialValues?.display_name || '',
        country: initialValues?.address.country || '',
        postal_code: initialValues?.address.postal_code || '',
        state: initialValues?.address.state || '',
        city: initialValues?.address.city || '',
        line1: initialValues?.address.line1 || '',
        line2: initialValues?.address.line2 || ''
    };

    return (
        <Grid container>
            <ReadersList />
            <Formik initialValues={defaultValues} enableReinitialize onSubmit={onSubmit}>
                {({ isSubmitting, dirty }) => (
                    <>
                        {stripeError && <Alert severity="error">{stripeError}</Alert>}
                        <RouterPrompt when={!!dirty && !submitLocation} />
                        <Form>
                            <Grid item container xs={12} spacing={2}>
                                <FormSection title="Location data">
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        spacing={2}
                                        style={{ paddingLeft: '10px' }}
                                    >
                                        <Grid item xs={6}>
                                            <h5>Location ID</h5>
                                            {locationId}
                                        </Grid>
                                        {!isCreate && (
                                            <Grid item container xs={6}>
                                                <Grid item xs={12}>
                                                    <h5>Mode</h5>
                                                </Grid>
                                                <Grid
                                                    component="label"
                                                    container
                                                    alignItems="center"
                                                    spacing={1}
                                                >
                                                    <Grid item>
                                                        {initialValues?.livemode ? 'Live' : 'Test'}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <FormikInput
                                            name="display_name"
                                            label="Display name"
                                            xs={12}
                                        />
                                        <Grid container item xs={12} spacing={2}>
                                            <Grid item xs={12}>
                                                <h5>Address</h5>
                                            </Grid>
                                            <FormikInput name="country" label="Country" xs={6} />
                                            <FormikInput
                                                name="postal_code"
                                                label="Postal Code"
                                                xs={6}
                                            />
                                            <FormikInput name="state" label="State" xs={6} />
                                            <FormikInput name="city" label="City" xs={6} />
                                            <FormikInput name="line1" label="Line 1" xs={6} />
                                            <FormikInput name="line2" label="Line 2" xs={6} />
                                        </Grid>
                                    </Grid>
                                </FormSection>

                                <Grid item xs={6}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        Save
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={onBack}
                                        style={{ marginRight: '5px' }}
                                    >
                                        Back
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    </>
                )}
            </Formik>
        </Grid>
    );
};

export default LocationCreateOrEditForm;
